import { useState } from "react";
import { ModalContext } from "./ModalContext";

const ContextProvider = ({ children }) => {
  const [visibility, setVisibility] = useState(false);

  const mintModalHandle = () => {
    setVisibility(!visibility);
  };

  return (
    <ModalContext.Provider
      value={{
        visibility,
        mintModalHandle,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export default ContextProvider;
